var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAisparkle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 6.38257L22.125 8.44507L26.25 10.5076L28.3125 14.6326L30.375 10.5076L34.5 8.44507L30.375 6.38257L28.3125 2.25757L26.25 6.38257ZM18 22.8826L22.7889 20.4849L26.25 18.7576L22.7889 17.0302L18 14.6326L15.6023 9.8437L13.875 6.38257L12.1477 9.8437L9.75 14.6326L4.96113 17.0302L1.5 18.7576L4.96113 20.4849L9.75 22.8826L12.1477 27.6714L13.875 31.1326L15.6023 27.6714L18 22.8826ZM13.875 24.2168L12.515 21.5033L12.051 20.5816L11.1293 20.1175L8.41582 18.7576L11.1293 17.3976L12.051 16.9335L12.515 16.0119L13.875 13.2984L15.235 16.0119L15.699 16.9335L16.6207 17.3976L19.3342 18.7576L16.6207 20.1175L15.699 20.5816L15.235 21.5033L13.875 24.2168ZM28.3125 22.8826L26.25 27.0076L22.125 29.0701L26.25 31.1326L28.3125 35.2576L30.375 31.1326L34.5 29.0701L30.375 27.0076L28.3125 22.8826Z",
    fill: "url(#paint0_linear_5137_2022)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5137_2022",
    x1: 1.5,
    y1: 18.7576,
    x2: 34.5,
    y2: 18.7576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0046FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#6F10F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677083,
    stopColor: "#EB3776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6436"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAisparkle);
export default __webpack_public_path__ + "static/media/aisparkle.0c904d651c36c1677b8349d8a23da29b.svg";
export { ForwardRef as ReactComponent };